// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--tk7qO","icon":"_103a151b99--icon--AHaQc"};